import { type InjectionKey, type Ref, inject, ref } from "vue";

// Id (backoffice) du membre connecté, fourni par l'app hôte via `provide` au niveau racine.
// Les composants partagés (@carnet/ui) le consomment sans dépendre d'un composable web-only :
// une app qui ne le fournit pas (mobile tant que la validation n'est pas câblée) obtient `null`,
// et la logique de validation se comporte comme « pas le superviseur » (badges/labels masqués).
export const currentMemberIdKey = Symbol("currentMemberId") as InjectionKey<Ref<string | null>>;

const fallback = ref<string | null>(null);

export function useCurrentMemberId(): Ref<string | null> {
  return inject(currentMemberIdKey, fallback);
}
